const styles = theme => ({
  titleHead: {
    color: '#342D3D',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      padding: '0 15px',
    },
    '& h1': {
      fontWeight: '500',
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        marginBottom: '25px',
      },
    },
  },
  title: {
    fontWeight: '600',
    marginBottom: '7px',
  },

  // Search filters
  filtersWrapper: {
    margin: '40px 0px',
    display: 'grid',
    gridTemplateColumns: '12fr',
    columnGap: '8px',
    rowGap: '8px',
  },
  nonUAEInput: {
    textAlign: 'center',
    '&::placeholder': {
      color: '#130F26',
    },
  },
  filtersMenu: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
    columnGap: '8px',
  },
  districtFilter: {},
  statusFilter: {},
  filtersMenuCollapsed: {
    gridRowStart: 2,
    gridColumnStart: 1,
    gridColumnEnd: 4,
    '& $collapsedfiltersMenu': {
      display: 'flex',
      flexWrap: 'wrap',
      columnGap: '8px',
      rowGap: '8px',
      '& > div': {
        minWidth: '130px',
        maxWidth: '170px',
      },
    },
  },
  collapsedfiltersMenu: {},
  moreBtnContainer: {
    height: '55px',
    minWidth: '160px',
    '& > button': {
      width: '100%',
      height: '100%',
      border: '1px solid ' + theme.palette.primary.adgmGreen,
      color: theme.palette.primary.adgmGreen,
      borderRadius: '0px',
      fontWeight: 'normal',
      textTransform: 'none',
      fontSize: '14px',
    },
  },
  searchBtnContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '1rem 0 1rem 0',
    '& $searchBtn': {
      height: '55px',
      minWidth: '165px',
      background: theme.palette.primary.main,
      borderRadius: '0px',
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 600,
      '&:disabled': {
        background: theme.palette.primary.darkGrey,
      },
    },
    '& $resetBtn': {
      color: theme.palette.primary.main,
      fontSize: '14px',
      textTransform: 'none',
      fontWeight: 500,
      '&:disabled': {
        color: theme.palette.primary.darkGrey,
      },
    },
  },
  searchBtn: {},
  resetBtn: {},
  selectBox: {
    verticalAlign: 'middle',
    justifyContent: 'center',
    padding: '14px 8px',
    borderColor: '#CED1D6 !important',
    '& p': {
      fontSize: '14px',
      color: theme.palette.primary.adgmBlack,
    },
  },
  filterItemHidden: {
    display: 'none',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      fontSize: '14px',
      '& .MuiOutlinedInput-input': {
        borderRadius: '0px',
        padding: '19.2px 14px !important',
      },
    },
  },
  textInput: {
    textAlign: 'center',
  },

  // Lease fields
  inputCheckbox: {
    flexShrink: '0',
    '& svg': {
      height: '30px',
      width: '30px',
    },
    '& input:checked + svg': {
      color: '#1FCACC',
    },
    '& input:checked + div': {
      color: theme.palette.primary.main,
    },
  },
  unitForm: {
    padding: '28px 0',
    borderTop: '1px solid #EBEEF3',
    borderBottom: '1px solid #EBEEF3',
    fontSize: '14px',
    color: '#342D3D',
    fontWeight: '500',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '14px',
    '& $adgmTextField': {
      '& > div': {
        alignItems: 'stretch',
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      gap: '0px',
      '& > div': {
        padding: '16px 16px 0px 16px',
      },
      '& > div:nth-child(2)': {
        borderBottom: '8px solid #EBEEF3',
        paddingBottom: '16px',
      },
      '& > div:last-child': {
        borderBottom: '8px solid #EBEEF3',
        paddingBottom: '16px',
      },
    },
  },
  adgmTextField: {},
  adornmentField: {
    '& .MuiOutlinedInput-root': {
      '& .MuiOutlinedInput-input': {
        padding: '0px 14px !important',
      },
    },
  },
  inputAdornmentRoot: {
    borderRight: '1px solid #CED1D6',
    maxHeight: '100%',
    padding: '17.5px 0px',
    paddingRight: '9px !important',
    alignItems: 'center',
    '& p': {
      color: '#342D3D',
    },
  },
  tooltipOpner: {
    color: '#1C999B',
    padding: '0',
    minWidth: 'auto',
  },

  // Property Toggle
  mobilefilterframe: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px 15px',
  },
  mobilefiltertext: {
    padding: '6.5px 12px',
    border: '1px solid #D2374F',
    boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
    borderRadius: '0px',
    margin: '0 4px 0 0',
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    flexShrink: '0',
    minWidth: 'auto',
    '&:hover': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '& img': {
      marginRight: '7px',
    },
  },
  adgmGreen: {
    background: '#1C999B',
    color: '#fff',
  },
  sideBarNavlist: {
    display: 'flex',
    overflow: 'auto',
    flexGrow: '1',
    '& span': {
      fontSize: '12px',
      fontWeight: '500',
    },
    '& $sidebarListItem': {
      padding: '4px 13px',
      border: '1px solid #1FCACC',
      boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.2)',
      borderRadius: '0px',
      margin: '0 2px',
      width: 'auto',
      '&:hover': {
        background: '#1C999B',
        color: '#fff',
      },
      '&:focus': {
        background: '#1C999B',
        color: '#fff',
      },
    },
  },
  sidebarListItem: {},

  [theme.breakpoints.up('md')]: {
    unitForm: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gap: '8px',
      '& p': {
        fontSize: '14px',
      },
    },
    titleHead: {
      flexWrap: 'nowrap',
      alignItems: 'center',
      flexDirection: 'row',
      '& h1': {
        fontSize: '1.5rem',
        '&:after': {
          height: '0',
          background: 'transparent',
        },
      },
      '& $textGray': {
        marginLeft: 'auto',
      },
    },
    mobilefilterframe: {
      padding: '0',
    },
    mobilefiltertext: {
      fontSize: '14px',
    },
    sideBarNavlist: {
      padding: '8px 0',
      '& span': {
        fontSize: '14px',
      },
    },
  },
  [theme.breakpoints.down('sm')]: {
    title: {
      fontSize: '16px',
    },
    inputAdornmentRoot: {
      '& p': {
        fontSize: '12px',
      },
    },
    inputCheckbox: {
      position: 'absolute',
      right: '0',
      top: '0',
    },
  },
});

export default styles;
